<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="[
                        'btnRetrieve', //Retrieve
                    ]"
                      @btnRetrieve="btnRetrieve()"
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <i-label :label="'Submit Date : '" />
                        <v-col cols="2">
                          <DxDateBox
                              :value="stDte"
                              height="30px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                          />
                        </v-col>
                        <span class="pa-1 subTitle"> ~ </span>
                        <v-col cols="2">
                          <DxDateBox
                              :value="edDte"
                              height="30px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {edDte = e.value && getEndFormat(e.value)}"
                          />
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <DxDataGrid id="epms6010"
                              class="listBox"
                              :ref="epms6010Ref"
                              :data-source="gridMainList"
                              :remote-operations="false"
                              :hover-state-enabled="true"
                              :allow-column-resizing="true"
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true"
                              :show-borders="true"
                              :width="grid.width"
                              :show-row-lines="true"
                              key-expr="rnum"
                              :focused-row-enabled="true"
                              :column-hiding-enabled="false"
                              :selection="{ mode: 'none' }"
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <DxColumn data-field="quotNoDisp" caption="Quotation No" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="quotTitle" caption="Quotation Title" width="25%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="buyerName" caption="Purchase Charger" width="15%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="poStat" caption="Success" width="10%" data-type="string" alignment="center" cell-template="poNoTemplate" :allow-editing="false" />
                      <template #poNoTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="poDetail(data)" >
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxColumn data-field="quotStepDesc" caption="Quotation Step" width="10%" data-type="string" alignment="center" :allow-editing="false" cell-template="quotNoTemplate"/>
                    <template #quotNoTemplate="{ data }">
                      <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="quotDetail(data)" >
                        {{data.text}}
                      </v-btn>
                    </template>
                    <DxColumn data-field="receiveDte" caption="Receive Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="submitDte" caption="Submit Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="" caption="View Sheet" width="10%" data-type="string" alignment="center" :allow-editing="false"  cell-template="receiptTemplate"/>
                    <template #receiptTemplate="{ data }">
                      <div>
                        <div class="float-left">
                          <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="viewSheet(data, 'POR')" >
                            <v-icon small class="mt-n1">
                              mdi-arrow-right-box
                            </v-icon>
                            POR
                          </v-btn>
                        </div>
                        <div class="float-left">
                          <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="viewSheet(data, 'BOM')" >
                            <v-icon small class="mt-n1">
                              mdi-arrow-right-box
                            </v-icon>
                            BOM
                          </v-btn>
                        </div>
                      </div>
                    </template>
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import {getDateFormat, getLastDate2, getCurrentDate, getPreMonth, getFirstDay, getFirstDate} from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import { epms6010 } from '@/api/view/hip/I/epms6010'
import {reportView} from "@/api/view/hip/common/common";

export default {
  name: 'epms6010',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      stDte : '',
      edDte : '',
      epms6010Ref: 'epms6010Ref',
      gridMainList: [{rnum: 1}],

      //cell merge
      mergeElements: [],
      mergeStartElements: [],

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms7050Ref)
    },
  },
  mounted() {
    this.init()
    this.doSearchMain()
  },
  methods: {
    init(){
      //to-do
      //this.stDte = getFirstDate();
      this.stDte = getLastDate2('m', { mm: -10 })
      this.edDte = getLastDate2('m', { mm: 0 })
    },
    getStrFormat(date) {
      this.stDte = getDateFormat(date)
      return getDateFormat(date)
    },
    getEndFormat(date) {
      this.edDte = getDateFormat(date)
      return getDateFormat(date)
    },
    btnRetrieve(){
      this.doSearchMain()
    },

    poDetail(e){
      this.$router.push({name: 'epms4010' , params:{poNo: e.data['poNo'] , stDte: this.stDte , edDte: this.edDte , porNo: this.porNo}});
    },

    quotDetail(e){
      this.$router.push({name: 'epms6020' , params:{quotNo: e.data['quotNo'] , quotStep: e.data['quotStep']}});
    },

    viewSheet(e, gbn){
      let fileName = '';
      if(gbn === 'POR'){
        fileName = 'por_sheet.jrxml'
      }
      else if(gbn === 'BOM'){
        fileName = 'bom_list.jrxml'
      }
      const param = {
        fileName : fileName,
        as_quot_no: e.data['poNo']
      }
      this.openLoading('searching')
      reportView(param)
          .finally(() => {
            this.endLoading()
          })

      // const param = {
      //   fileName: 'epms4010.jrxml',
      //   as_po_no: e.values[1],
      //   as_maker_cd: this.$store.state.user.makerCd
      // }
      // this.openLoading('searching')
      // reportView(param)
      //     .finally(() => {
      //       this.endLoading()
      //     })
    },

    async doSearchMain(){
      this.openLoading('searching')

      let params = {
        makerCd: this.$store.state.user.makerCd,
        stDte : this.stDte,
        edDte : this.edDte,
      }


      await epms6010(params).then(res => {
        res.list.forEach(function(data){
          data['quotNoDisp'] = data['quotNo']

          if(data['seq'] !== '1'){
            data['quotNoDisp'] = data['quotTitle'] = data['buyerName'] = data['poStat'] = '';
          }
          else{
            if(data['poStat'] === '3')
              data['poStat'] = 'Waiting'
            else
              data['poStat'] = 'P.O.'
          }
        })


        this.gridMainList = res.list
      }).finally(() => {
        this.endLoading()
      })
    },

  }
}
</script>
<style lang="scss" scoped>
.subTitle {
  font-weight: bold;
  color: black;
}
.v-btn {
  text-transform: unset !important;
  // height: 16px !important;
}
.receiptBtn {
  font-weight: bold;
}
.receiptBtn:hover {
  color: #4980BC;
}
</style>